var _style, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "iPads",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#B1DFDC;}\n\t.st1{fill:#00897A;}\n\t.st2{fill:#46B5AC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,25.5L36,0l25.4,10.6L72,36L46.5,25.5z M10.6,61.4L0,36l25.5,10.5L36,72L10.6,61.4z M46.5,46.5L72,36 L61.4,61.4L36,72L46.5,46.5z M10.6,10.6L36,0L25.5,25.5L0,36L10.6,10.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72,36H36l10.5-10.5L72,36z M25.5,46.5L0,36h36L25.5,46.5z M36,72V36l10.5,10.5L36,72z M25.5,25.5L36,0v36 L25.5,25.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36,36V0l10.5,25.5L36,36z M25.5,46.5L36,36v36L25.5,46.5z M36,36h36L46.5,46.5L36,36z M25.5,25.5L36,36H0 L25.5,25.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoGreen);
export default __webpack_public_path__ + "static/media/logo-green.725bb483ae05c78ca1c49808cc569e70.svg";
export { ForwardRef as ReactComponent };